import ArrowRightIcon from '@eduzz/houston-icons/ArrowRight';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import clsx from 'clsx';
import { useFormikContext } from 'formik';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { useStyles } from './styles';
import { useStepper } from '../../context';
import { fieldsByStep } from '../../form';

import type { NewBankAccount } from '../../form';

const SUMMARY_STEP = 4;

function Footer() {
  const { currentStep, nextStep } = useStepper();
  const history = useHistory();
  const { values, dirty, errors, status, handleSubmit, isSubmitting } = useFormikContext<NewBankAccount>();
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const isCrossborder = user?.international_account || user?.crossborder;
  const classes = useStyles();

  const hasSubmitted = status === 'submitted';
  const hasVerified = status === 'verified';
  const isSubmitStep = currentStep === SUMMARY_STEP;

  function getStepFieldError(fields: string[]) {
    return Object.entries(errors)
      .find(([key]) => fields.includes(key))
      ?.pop();
  }

  function getButtonTitle() {
    if (isSubmitStep) return 'Enviar';
    if (hasSubmitted) return 'Verificar código';
    if (hasVerified) return 'Finalizar';
    return 'Continuar';
  }

  function getButtonClickHandler() {
    if (isSubmitStep || hasSubmitted) return () => handleSubmit();
    if (hasVerified) return () => history.push('/producer/profile/bankdata');
    return nextStep;
  }

  const stepFields = fieldsByStep[isCrossborder ? 'crossborder' : 'national'][currentStep - 1];
  const hasFieldsInStep = !!stepFields?.length;
  const errorMessage = hasFieldsInStep && getStepFieldError(stepFields);
  const shouldDisableBtn = (!dirty && !values.id) || !!errorMessage;

  return (
    <footer className={classes.root}>
      <Tooltip title={(shouldDisableBtn ? errorMessage : '') || ''} placement='top'>
        <span>
          <Button
            id='step-submit-btn'
            type='submit'
            disabled={isSubmitting}
            startIcon={isSubmitting && <CircularProgress size={20} />}
            className={clsx(classes.btn, shouldDisableBtn && '--disabled')}
            endIcon={<ArrowRightIcon />}
            onClick={shouldDisableBtn ? undefined : getButtonClickHandler()}
            variant='contained'
            color='primary'
          >
            {!isSubmitting ? getButtonTitle() : 'Enviando...'}
          </Button>
        </span>
      </Tooltip>
    </footer>
  );
}

export { Footer };
